<template>
  <div class="project-list">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>项目列表</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称/编号/备注"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|array-integer#and': '0,1',
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'regex:memo|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'projectList',
                title: '项目列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员工单编号/姓名/手机号"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doView(scope.row)">
                    查看项目明细
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="项目明细"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
      custom-class="project-detail-dialog"
    >
      <el-collapse v-model="activeNames">
        <el-collapse-item title="项目概要" name="1">
          <div style="padding:0 15px 15px">
            <el-descriptions class="margin-top" :column="2" :size="size" border>
              <template v-for="(field, i) in extFields">
                <el-descriptions-item
                  v-if="field.showList.indexOf('2') != -1"
                  :key="i"
                  labelStyle="width:150px"
                  contentStyle="width:350px;"
                >
                  <template slot="label">
                    {{ field.nameDisp }}
                  </template>
                  {{ formatValue(field) }}
                </el-descriptions-item>
              </template>
            </el-descriptions>
          </div>
        </el-collapse-item>
        <el-collapse-item title="项目成本" name="2">
          <div style="margin:0 0 15px 15px;font-weight:600">
            材料和机措
            <span v-if="formData.projectConsumptionCost || formData.projectConsumptionCost === 0">
              （合计：¥ {{ formData.projectConsumptionCost }}）
            </span>
          </div>
          <div style="padding:0 15px 15px">
            <el-table :data="formData.projectConsumptionList" border class="c-table-border">
              <el-table-column prop="name" label="名称" width="485px"></el-table-column>
              <el-table-column label="类型" width="150px">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.type == 'material' ? '' : 'success'">
                    {{
                      scope.row.type == 'material'
                        ? '材料'
                        : scope.row.type == 'measure'
                        ? '机措'
                        : '其他'
                    }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="quantity" label="数量" width="167.5px"></el-table-column>
              <el-table-column label="单位" width="167.5px">
                <template slot-scope="scope">
                  {{ scope.row.unit ? osg.codelabel('unit', scope.row.unit) : '' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin:0 0 15px 15px;font-weight:600">
            工人
            <span v-if="formData.projectLabourCost || formData.projectLabourCost === 0">
              （合计：¥ {{ formData.projectLabourCost }}）
            </span>
          </div>
          <div style="padding:0 15px 15px">
            <el-table :data="formData.labourList" border class="c-table-border">
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="phone" label="电话"></el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
        <el-collapse-item title="项目收入" name="3">
          <div style="padding:0 15px 15px">
            <el-descriptions :column="2" direction="vertical" border style="margin-bottom: 15px;">
              <el-descriptions-item labelStyle="width:50%">
                <template slot="label">
                  合同签约金额（优惠后）
                </template>
                ¥ {{ formData.afterRefundMoney }}
              </el-descriptions-item>
              <el-descriptions-item labelStyle="width:50%">
                <template slot="label">
                  已收款总金额
                </template>
                ¥ {{ formData.paidAmount }}
              </el-descriptions-item>
            </el-descriptions>
            <el-table :data="formData.payList" border class="c-table-border">
              <el-table-column prop="executor" label="付款人"></el-table-column>
              <el-table-column
                prop="payType"
                label="付款方式"
                :formatter="formatterPayType"
              ></el-table-column>
              <el-table-column prop="payTime" label="付款时间" width="140px"></el-table-column>
              <el-table-column
                prop="tradeIn"
                label="款项来源"
                :formatter="formatterTradeIn"
              ></el-table-column>
              <el-table-column
                prop="type"
                label="类型"
                :formatter="formatterPaymentRecordType"
              ></el-table-column>
              <el-table-column prop="paidAmount" label="已收款金额" width="100px"></el-table-column>
              <el-table-column prop="difference" label="未付金额" width="100px">
                <template slot-scope="scope">
                  <span :style="`${scope.row.difference < 0 ? 'color:red' : 'color:#000'}`">
                    {{ scope.row.difference }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="price"
                label="本次审核金额(元)"
                width="120px"
              ></el-table-column>
              <el-table-column
                prop="orderType"
                label="款项类型"
                :formatter="formatterOrderType"
              ></el-table-column>
              <el-table-column prop="memo" label="备注" show-overflow-tooltip></el-table-column>
              <el-table-column prop="body" label="审批批语" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
        <el-collapse-item
          :title="
            '项目利润' +
              (formData.projectProfit || formData.projectProfit === 0
                ? `（¥ ${formData.projectProfit}） `
                : '')
          "
          name="4"
        >
          <div style="padding:0 15px 15px;font-size: 14px">
            计算公式为：项目利润 = 合同增减项后金额 - 材料和机措成本价合计 - 人工费用合计
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      tenantId: '',
      name: 'projectList',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { exts: {} },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {
        codecfg_unit: { codeId: 'company' },
        codecfg_payType: { codeId: 'payType' },
        codecfg_orderPayType: { codeId: 'orderPayType' },
        codecfg_tradeIn: { codeId: 'tradeIn' }
      },
      area: {
        options: this.osg.areaList
      },
      activeNames: ['1', '2', '3', '4']
    };
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('projectList', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:contactsName|string#or': this.searchValue,
        'regex:contactsPhone|string#or': this.searchValue,
        'regex:serviceAppointmentNum|string#or': this.searchValue,
        'exists:projectManagerId|boolean#and': true,
        'exists:projectStatus|boolean#and': true,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/contract/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doView(row) {
      this.formData = row;
      this.openDetail = true;
      this.getDetail(row._id);
    },
    getDetail(id) {
      this.osg.ajax('basic/project/getLedgerById.do', { id }, res => {
        this.formData = res.data;
      });
    },
    formatValue(field) {
      let fieldName = field.name;
      let fieldValue = field.preset ? this.formData[fieldName] : this.formData.exts[fieldName];
      if (field.valueOption) {
        if (field.type == 'cascade') {
          if (field.multiple) {
            return this.osg.formatCascadeMultiple(field.valueOption, fieldValue);
          } else {
            return this.osg.formatCascade(field.valueOption, fieldValue);
          }
        } else {
          if (field.multiple) {
            return this.osg.codelabelForArray(field.valueOption, fieldValue);
          } else {
            return this.osg.codelabel(field.valueOption, fieldValue);
          }
        }
      } else if (fieldName == 'province') {
        return this.osg.formatProvince(null, null, fieldValue);
      } else if (fieldName == 'city') {
        return this.osg.formatCity(null, null, fieldValue);
      } else if (fieldName == 'district') {
        return this.osg.formatDistrict(null, null, fieldValue);
      } else if (fieldName == 'subdistrict') {
        return this.osg.formatSubdistrict(null, null, fieldValue);
      } else {
        return fieldValue;
      }
    },
    formatterPaymentRecordType(row) {
      if (!row) return '未知';
      return row.price > 0 ? '支付' : '退款';
    },
    formatterPayType(row, column, cellValue) {
      return this.osg.codelabel('payType', cellValue);
    },
    formatterOrderType(row, column, cellValue) {
      return this.osg.codelabel('orderPayType', cellValue);
    },
    formatterTradeIn(row, column, cellValue) {
      return this.osg.codelabel('tradeIn', cellValue);
    }
  }
};
</script>
<style lang="scss">
#app {
  .project-list {
    .project-detail-dialog {
      .el-dialog__header {
        border-bottom: none !important;
      }
      .el-dialog__body {
        padding: 0 !important;
      }
      .el-collapse-item__header {
        padding-left: 15px !important;
        font-size: 16px;
        color: #409eff;
      }
      .el-collapse-item__content {
        padding-bottom: 0;
      }
      .el-table {
        th.el-table__cell {
          background-color: #fafafa;
        }
      }
    }
  }
}
</style>
